import { render, staticRenderFns } from "./BankEmployeeInvite.vue?vue&type=template&id=74b28ce7&"
import script from "./BankEmployeeInvite.vue?vue&type=script&lang=js&"
export * from "./BankEmployeeInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QForm,QInput} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QForm,QInput})
